var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useMemo } from 'react';
import store from './_store';
import wrapTWithDefaultNs from './wrapTWithDefaultNs';
import I18nContext from './context';
import transCore from './transCore';
function useTranslationInPages(defaultNS) {
    var ctx = useContext(I18nContext);
    return useMemo(function () { return (__assign(__assign({}, ctx), { t: wrapTWithDefaultNs(ctx.t, defaultNS) })); }, [ctx, defaultNS]);
}
function useTranslationAppDir(defaultNS) {
    var _a = store.get(), lang = _a.lang, namespaces = _a.namespaces, config = _a.config;
    var localesToIgnore = config.localesToIgnore || ['default'];
    var ignoreLang = localesToIgnore.includes(lang);
    var t = transCore({
        config: config,
        allNamespaces: namespaces,
        pluralRules: new Intl.PluralRules(ignoreLang ? undefined : lang),
        lang: lang,
    });
    return { t: wrapTWithDefaultNs(t, defaultNS), lang: lang };
}
export default function useTranslation(defaultNS) {
    var appDir = store.get();
    var useT = (appDir === null || appDir === void 0 ? void 0 : appDir.config) ? useTranslationAppDir : useTranslationInPages;
    return useT(defaultNS);
}
